import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconCalendar } from '../../assets/icons/IconCalendar';
import { TranslationKey } from '../../i18n/translationKeys';
import { useLanguageStore } from '../../stores/languageStore';
import { formatShortDate } from '../../utils/formatters';

interface StatementSentNoteProps {
    sentOn: string | null | undefined;
    className?: string;
    /** Calendar icon and the date leading the line, as an entry of the reminder detail. */
    dated?: boolean;
}

export const StatementSentNote: React.FC<StatementSentNoteProps> = ({ sentOn, className = '', dated = false }) => {
    const { t } = useTranslation();
    const lang = useLanguageStore(s => s.lang);
    if (!sentOn) return null;
    const date = formatShortDate(`${sentOn}T00:00:00`, lang);
    if (dated) {
        return (
            <p data-testid="statement-sent-note" className={`flex items-center gap-s text-supporting text-content-secondary ${className}`}>
                <IconCalendar aria-hidden="true" className="shrink-0 text-content-secondary" />
                {t(TranslationKey.CustomerFollowUp.StatementSentDated, { date })}
            </p>
        );
    }
    return (
        <p data-testid="statement-sent-note" className={`text-supporting text-content-subtle ${className}`}>
            {t(TranslationKey.CustomerFollowUp.StatementSent, { date })}
        </p>
    );
};
